"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetProviders = void 0;
var react_1 = require("react");
var keys_1 = require("../keys");
var useMutation_1 = require("../useMutation");
var useGetProviders = function (_a) {
    var _b = _a === void 0 ? {} : _a, successAction = _b.successAction, isAutoCall = _b.isAutoCall;
    var _c = (0, useMutation_1.useMutation)({
        successAction: successAction,
        path: keys_1.GET_PROVIDERS,
    }), mutate = _c.mutate, isSubmitting = _c.isSubmitting, data = _c.data, error = _c.error;
    (0, react_1.useEffect)(function () {
        if (isAutoCall) {
            mutate({ page: 0, limit: 1000 });
        }
    }, []);
    return (0, react_1.useMemo)(function () { return ({
        getProviders: mutate,
        data: data === null || data === void 0 ? void 0 : data.data,
        isSubmitting: isSubmitting,
        error: error,
    }); }, [mutate, isSubmitting, data, error]);
};
exports.useGetProviders = useGetProviders;
